module.exports = __webpack_public_path__ + "assets/1fde6f73540d376b123f2019aeb04dc7.mp3";